import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { usersBackend } from './users.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { usersReducer } from './users.reducer';

// FIXME: remove that
backend.users = usersBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('users', usersReducer),
    /* DatastoreBackendModule.forFeature(
      'users',
      usersBackend,
    ),*/
  ],
})
export class DatastoreUsersModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/users/users.module.ts